import { FC, useEffect, useState } from 'react'
import ExamTypeApi from '../../../../infrastructure/api/ExamTypeApi'
import { KTSVG } from '../../../../_metronic/helpers'
import { Modal } from 'react-bootstrap-v5'
import { useFormik } from 'formik'
import {
  IExamTypeModel,
  examTypeInitValues,
} from '../../../../models/responses/ExamTypeModel'
import { IExamTypeRequestModel } from '../../../../models/requests/ExamTypeRequestModel'
import { ExamTypeFormValidations } from '../../../validations/ExamTypeFormValidations'
import { FormikValidationError } from '../../../components/validations/FormikValidationError'
import { SaveChangesButton } from '../../../components/buttons/SaveChangesButton'

type Props = {
  itemId: string
  show: boolean
  handleClose: () => void
}

const ExamTypeFormModal: FC<Props> = ({ itemId, show, handleClose }) => {
  const [loading, setLoading] = useState(false)
  const [complete, setComplete] = useState(false)
  const [examType, setExamType] = useState<IExamTypeModel>(examTypeInitValues)
  const [isVisible, setVisible] = useState<boolean>(false)

  const updateExamType = (fieldsToUpdate: Partial<IExamTypeModel>) => {
    const updatedData = { ...examType, ...fieldsToUpdate }
    setExamType(updatedData)
  }

  const formik = useFormik<IExamTypeModel>({
    initialValues: examType,
    enableReinitialize: true,
    validationSchema: ExamTypeFormValidations,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setTimeout(async () => {
        let model: IExamTypeRequestModel = {
          id: values.id === '' ? undefined : values.id,
          isVisible: isVisible,
          title: values.title
        }
        process(model)
      }, 500)
    },
  })

  async function process(model: IExamTypeRequestModel) {
    try {
      var result = undefined
      if (model.id === undefined || model.id === '')
        result = await ExamTypeApi.AddExamType(model)
      else {
        result = await ExamTypeApi.UpdateExamType(model)
      }
      formik.resetForm()
      handleClose()
    } catch (error) {
      alert('Error: ' + error)
      setLoading(false)
    }
    setLoading(false)
  }

  async function init() {
    let result: IExamTypeModel
    if (itemId !== '') {
      var response = await ExamTypeApi.GetExamType(itemId)
      setVisible(response.data.isVisible)
      result = response.data
    } else {
      result = examTypeInitValues
    }
    setExamType(result)
  }

  const handleChangeVisible = () => {
    setVisible(!isVisible)
  }

  useEffect(() => {
    formik.resetForm()
    if (show) init()
  }, [itemId, show])

  return (
    <Modal
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-600px h-auto'
      show={show}
      onHide={handleClose}
    >
      <form className='form w-100' onSubmit={formik.handleSubmit} noValidate>
        <div className='modal-content'>
          <div className='modal-header pb-0 border-0 justify-content-end'>
            <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
              <KTSVG path='/media/icons/duotone/Navigation/Close.svg' className='svg-icon-1' />
            </div>
          </div>
          <div className='modal-body mx-5 mx-xl-18 pt-0 pb-15'>
            <div className='text-center mb-13'>
              <h1 className='mb-3'>{itemId === '' ? 'Add' : 'Edit'} Exam Type</h1>
              <div className='text-muted fw-bold fs-5'>
                Exam Management <small>Educall</small>
              </div>
            </div>
            <div className='mb-10'>
              <label className='form-label fw-bolder required'>Title</label>
              <input
                {...formik.getFieldProps('title')}
                type='text'
                name='title'
                className='form-control form-control-solid'
                placeholder='Entry..'
              />
              <FormikValidationError touched={formik.touched.title} error={formik.errors.title} />
            </div>
            <div className='form-check form-switch form-check-custom form-check-solid mb-10 me-10'>
              <input
                {...formik.getFieldProps('isVisible')}
                className='form-check-input h-30px w-50px'
                type='checkbox'
                name='isVisible'
                checked={isVisible}
                onClick={handleChangeVisible}
              />
              <FormikValidationError touched={formik.touched.isVisible} error={formik.errors.isVisible} />
              <label className='form-check-label'>Is Visible</label>
            </div>
          </div>
          <div className='modal-footer'>
            <div className='d-flex flex-center '>
              <SaveChangesButton
                loading={loading}
                setLoading={setLoading}
                complete={complete}
                setComplete={setComplete}
                valid={formik.isValid}
                submit={formik.isSubmitting}
                setSubmit={formik.submitForm}
              />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  )
}

export { ExamTypeFormModal }
